import React, { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useNavigate, useLocation } from 'react-router-dom';
import BorderColorSharpIcon from '@mui/icons-material/BorderColorSharp';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import VisibilityIcon from '@mui/icons-material/Visibility';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import {
    InspectionContents,
    GrayButton,
    NomalButton
} from '../../css/CSS.js';

import { visuallyHidden } from '@mui/utils';
import VisitReportDelConfirm from "./VisitReportDelConfirm"

import LoadingDialog from '../../Loading';
import useAuthAxios from "../../../useAuthAxios";
import InspectionBreadcrumbs from '../InspectionBreadcrumbs.js';

export default function ReportlistBody() {
    const navigate = useNavigate();

    const pathName = useLocation().pathname;
    const term = pathName.split("/").slice(-3)[0];

    const location = useLocation();
    const keyData = location.state?.listdata;
    const customer = location.state?.customer;
    const koji = location.state?.koji;
    const shiten = location.state?.shiten;
    const teimei = location.state?.teimei;


    const Header = styled(TableRow)({
        backgroundColor: "#289bdf",
    });
    const Text = styled(Typography)({
        color: "#FFFFFF",
        transform: "scale(0.9)",
    });
    const TableFlame = styled(TableContainer)({
        borderRadius: "10px 10px 0 0",
    });
    const CLTableCell = styled(TableCell)({
        padding: "5px",
    });
    const Works = styled(Button)({
        color: "#000000",
    });

    let deleteAuth = false;

    if (localStorage.getItem("inspectionRecordDelete") === "1") {
        deleteAuth = true;
    }

    const deleteMode = false;
    const [list, setList] = useState();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [processing_search] = useState(false);
    const [processing, setProcessing] = useState(false);
    const disable_processing = useRef(false);
    const [kojiCD, setKojiCD] = useState('');
    const [rptShubetsu, setRptShubetsu] = useState('');
    const [rptShubetsuName, setRptShubetsuName] = useState('');
    const [rptSeq, setRrptSeq] = useState('');
    const [mngNo, setMngNo] = useState('');
    const [delDialog, setDelDialog] = useState(false);

    const authAxios = useAuthAxios();

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                reportSort: {
                    order: isAsc ? 'desc' : 'asc',
                    orderBy: property,
                }
            }
            sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(newCondition));
        }
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        //実績日付のソート想定
        if (!b[orderBy] && !a[orderBy]) return 0;
        if (!a[orderBy]) return 1;
        if (!b[orderBy]) return -1;
        return 0;
    }
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function stableSort(array, comparator) {
        const stabilizedThis = array?.map((el, index) => [el, index]);
        stabilizedThis?.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis?.map((el) => el[0]);
    }

    const handleChangePage = (event, newPage) => {
        const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                reportPagination: {
                    ...searchConditions.reportPagination,
                    page: newPage,
                }
            }
            sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(newCondition));
        }
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setRowsPerPage(newPageSize);
        const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                reportPagination: {
                    page: 0,
                    pageSize: newPageSize
                }
            }
            sessionStorage.setItem('visitReportSearchCondition', JSON.stringify(newCondition));
        }
        setPage(0);
    };

    const visitOnClick = (kojiCD, rptShubetsu) => {
        //navigate("/inspection/visitReport/edit");
        if (disable_processing.current === true) { return; }

        disable_processing.current = true;
        setProcessing(true);
        authAxios
            .post('api/visitReport/detail/' + kojiCD + "/" + rptShubetsu + "?inputType=0", visitReportList)
            .then(response => {
                if (response.status === 200) {
                    let newSeqNo = response.data.newSeqNo
                    authAxios
                        .get('api/visitReport/detail/' + kojiCD + "/" + rptShubetsu + '/' + response.data.newSeqNo)
                        .then(response => {
                            if (response.status === 200) {
                                const getFormdata = JSON.parse((JSON.stringify(response.data)));
                                navigate("/inspection/visitReport/edit", {
                                    state: {
                                        getFormdata: getFormdata,
                                        formatData: getFormdata,
                                        keyData: {
                                            kojiCD: kojiCD,
                                            shiten: shiten,
                                            teimei: teimei,
                                            customer: customer,
                                            rptShubetsu: rptShubetsu,
                                            rptSeq: newSeqNo,
                                            inputType: 0,
                                            canEdit: location.state?.canEdit,
                                            canFix: location.state?.canFix,
                                            thokiYuryoFlg: location.state?.thokiYuryoFlg,
                                        },
                                    }
                                });
                            }
                        }).catch((response) => {
                            alert("作成中データの取得に失敗しました。", response.body);
                            setProcessing(false);
                        })
                    disable_processing.current = false
                }
            }).catch((response) => {
                alert("訪問記録の作成に失敗しました。", response.body);
                setProcessing(false);
                disable_processing.current = false
            })
    }

    const onSubmit_being = (kojiCD, rptShubetsu, rptSeq) => {
        if (!location.state?.canEdit) {
            return;
        }
        if (processing === true) { return; }
        setProcessing(true);
        authAxios
            .get('api/visitReport/detail/' + kojiCD + "/" + rptShubetsu + "/" + rptSeq)
            .then(response => {
                if (response.status === 200) {
                    const getFormdata = JSON.parse((JSON.stringify(response.data)));
                    navigate("/inspection/visitReport/edit", {
                        state: {
                            getFormdata: getFormdata,
                            formatData: getFormdata,
                            keyData: {
                                kojiCD: kojiCD,
                                shiten: shiten,
                                teimei: teimei,
                                customer: customer,
                                rptShubetsu: rptShubetsu,
                                rptSeq: rptSeq,
                                inputType: 1,
                                canEdit: location.state?.canEdit,
                                canFix: location.state?.canFix,
                                thokiYuryoFlg: location.state?.thokiYuryoFlg,
                            },
                        }
                    });
                }
                setProcessing(false);
            }).catch((response) => {
                alert("作成中データの取得に失敗しました。", response.body);
                setProcessing(false);
            })
    }

    const onSubmit_done = (kojiCD, rptShubetsu, rptSeq, status) => {
        if (processing === true) { return; }
        setProcessing(true);
        authAxios
            .get('api/visitReport/detail/' + kojiCD + "/" + rptShubetsu + "/" + rptSeq)
            .then(response => {
                if (response.status === 200) {
                    navigate("/inspection/" + term + "/" + term, {
                        state: {
                            keyData: {
                                kojiCD: kojiCD,
                                shiten: shiten,
                                teimei: teimei,
                                customer: customer,
                                status: status,
                                rptShubetsu: rptShubetsu,
                                rptSeq: rptSeq,
                                inputType: 1,
                                canEdit: location.state?.canEdit,
                                canFix: location.state?.canFix,
                                thokiYuryoFlg: location.state?.thokiYuryoFlg,
                            },
                        }
                    });
                }
                setProcessing(false);
            }).catch((response) => {
                alert("作成中データの取得に失敗しました。", response.body);
                setProcessing(false);
            })
    }

    const deleteChecked = (kojiCD, rptShubetsu, rptSeq, mngNo) => {
        setKojiCD(kojiCD);
        setRptShubetsu(rptShubetsu);
        setRrptSeq(rptSeq);
        setMngNo(mngNo);
        setRptShubetsuName("訪問記録");

        setDelDialog(true);
    }
    const onSubmit_delete = (kojiCD, rptShubetsu, rptSeq, mngNo) => {
        deleteChecked(kojiCD, rptShubetsu, rptSeq, mngNo);

    }

    const back = () => {
        navigate("/inspection/visitReport/customerlist");
    }

    const visitReportList =
    {
        "address": null,
        "azumaConstructure": '0',
        "bandoConstructure": '0',
        "besshiRecord": '0',
        "besshiRecordSheets": '0',
        "besshizumen": '0',
        "besshiZumenSheets": '0',
        "comfirmContent": null,
        "confirmCheck": '0',
        "csCheck": '0',
        "customerCD": null,
        "customerName": null,
        "customerSign": null,
        "deleverDate": null,
        "hokkaidoshiten": '0',
        "kansaishiten": '0',
        "kenmei": null,
        "kitakanntoshiten": '0',
        "kojiCD": '',
        "kurodaHouse": '0',
        "kyushushiten": '0',
        "mngNo": '',
        "nagoyashiten": '0',
        "otherCheck": '0',
        "repairCheck": '0',
        "repairTatiai": '0',
        "requestContent": null,
        "requestDate": null,
        "requestPerson": null,
        "schduleContent": null,
        "tantoSign": null,
        "tenkenShiten": null,
        "tenkenShitenCD": null,
        "tenkenTanto": null,
        "tenkenTimeFrom": null,
        "tenkenTimeTo": null,
        "tibashiten": '0',
        "todayContent": null,
        "touhokushiten": '0',
        "toukyoushiten": '0',
        "visitDate": null,
        "yokohamashiten": '0',
    }

    let headCells = [];
    headCells = [
        {
            id: 'mngNo',
            label: '管理No',
            align: 'left',
            width: '11%',
        },
        {
            id: 'jissekiDate',
            label: '実績',
            align: 'left',
            width: '11%',
        },
        {
            id: 'kenmei',
            label: '件名',
            align: 'left',
            width: '11%',
        },

        {
            id: 'status',
            label: '編集',
            align: 'left',
            width: '11%',
        },
        {
            id: 'delete',
            label: '削除',
            align: 'left',
            width: '11%',
        },
    ];

    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <Header sx={{ backgroundColor: props.mode === true ? "#C0C0C0" : "#289bdf" }}>
                    {headCells.map((headCell) => (
                        (headCell.id !== 'delete' || (deleteAuth === true && headCell.id === 'delete')) ?
                            <TableCell
                                key={headCell.id}
                                align={headCell.align}
                                width={headCell.width}
                                sortDirection={orderBy === headCell.id ? order : false}
                            >
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={createSortHandler(headCell.id)}
                                    disabled={headCell.id === 'delete'}
                                >
                                    <Text sx={{ color: props.mode === true ? "#000000" : "#FFFFFF" }}>{headCell.label}</Text>
                                    {orderBy === headCell.id ? (
                                        <Box component="span" sx={visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </Box>
                                    ) : null}
                                </TableSortLabel>
                            </TableCell>
                            : null
                    ))}
                </Header>
            </TableHead >
        );
    }

    const cancelClick = () => {
        setDelDialog(false);
    }

    const deleteClick = () => {
        setProcessing(true);
        authAxios.delete('api/visitReport/' + kojiCD + '/' + rptShubetsu + '/' + rptSeq + '/delete')
            .then(response => {
                if (response.status === 200) {
                    authAxios
                        .get('api/visitReport/visitReports/?kojiCD=' + kojiCD + '&customerCD=' + customer)
                        .then(response => {
                            if (response.status === 200) {
                                const listdata = JSON.parse((JSON.stringify(response.data)));
                                setList(listdata?.visitInfo);
                                setPage(0);
                                setProcessing(false);
                                setDelDialog(false);

                                //navigate("/inspection/visitReport/customerlist/reportlist", { state: { listdata: listdata, shiten: shiten, koji: kojiCD, teimei: teimei, customer: customer } });

                            } else if (response.status === 401) {
                                alert("認証に失敗しました。");
                                setProcessing(false);
                                setDelDialog(false);
                                switch (localStorage.getItem("loginType")) {
                                    case "0":
                                        navigate("/");
                                        break
                                    case "1":
                                        navigate("/omsuser");
                                        break
                                    case "2":
                                        navigate("/vender");
                                        break
                                    default:
                                        navigate("/");
                                }
                            }
                        }).catch((response) => {
                            alert("一覧情報取得に失敗しました。", response.body);
                            setProcessing(false);
                            setDelDialog(false);
                            switch (localStorage.getItem("loginType")) {
                                case "0":
                                    navigate("/");
                                    break
                                case "1":
                                    navigate("/omsuser");
                                    break
                                case "2":
                                    navigate("/vender");
                                    break
                                default:
                                    navigate("/");
                            }
                        });
                }
            }).catch((response) => {
                alert("作成済み訪問記録の削除に失敗しました。", response.body);
                setProcessing(false);
            });
        setTimeout(() => {
            setProcessing(false);
        }, 10000);
    }

    React.useEffect(() => {
        //初期リスト設定
        if (keyData?.visitInfo) {
            const previousCondition = sessionStorage.getItem('visitReportSearchCondition');
            if (previousCondition) {
                const searchConditions = JSON.parse(previousCondition);
                const sortedListData = stableSort(keyData.visitInfo, getComparator(searchConditions?.reportSort?.order, searchConditions?.reportSort?.orderBy))
                setList(sortedListData);
                setRowsPerPage(searchConditions?.reportPagination?.pageSize);
                setPage(searchConditions?.reportPagination?.page);
            } else {
                setList(keyData.visitInfo);
            }
        }
    }, []);

    return (<React.Fragment>
        <InspectionContents style={{ marginLeft: 0, marginRight: 0 }} maxWidth="xl">

            <VisitReportDelConfirm
                kojiCD={kojiCD}
                rptShubetsu={rptShubetsuName}
                kanriNO={rptSeq}
                mngNo={mngNo}
                open={delDialog}
                cancelClick={cancelClick}
                deleteClick={deleteClick} />
            <InspectionBreadcrumbs />

            <Grid container rowSpacing={2} columnSpacing={2}>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 1.2, backgroundColor: '#289bdf' }}>お客様NO</Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 1.2 }}>{customer}</Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 1.2, backgroundColor: '#289bdf' }}>工事CD</Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 1.2 }}>{koji}</Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 1.2, backgroundColor: '#289bdf' }}>支店名</Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 1.2 }}>{shiten}</Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 1.2, backgroundColor: '#289bdf' }}>邸名</Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 1.2 }}>{teimei}</Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <Typography sx={{ fontSize: '1.2rem', }}><Box component="section" sx={{ p: 2.4 }}></Box></Typography>
                </Grid>
                <Grid item xs="auto">
                    <NomalButton
                        className="confButton"
                        type="submit"
                        variant="contained"
                        size="large"
                        disabled={!location.state?.canEdit}
                        onClick={() => visitOnClick(koji, "VR")}
                        sx={{ transform: "scale(1.2)" }}
                    >訪問記録作成
                    </NomalButton>
                </Grid>
                <Grid item xs="auto">
                    <GrayButton
                        className="confButton"
                        type="button"
                        variant="contained"
                        size="large"
                        color="primary"
                        onClick={() => back()}
                        sx={{ transform: "scale(1.2)", ml: 4 }}>
                        <LowPriorityIcon sx={{ mr: 2, fontSize: '1.2rem' }} />
                        戻る
                    </GrayButton>
                </Grid>

            </Grid>


            <TableFlame sx={{ mt: 5 }}>
                <Table
                    align="center"
                >
                    <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={keyData?.length}
                        mode={deleteMode}
                    />
                    <TableBody>
                        {
                            stableSort(list, getComparator(order, orderBy))
                                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                ?.map((row, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            hover
                                            tabIndex={-1}>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.mngNo}</TableCell>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.jissekiDate}</TableCell>
                                            <TableCell align="left" sx={{ pr: 0 }}>{row.kenmei}</TableCell>

                                            {row.status === 1 ?
                                                <CLTableCell align="left" onClick={() => onSubmit_being(koji, "VR", row.reportSeqNo, shiten, teimei, customer)} >
                                                    <Works disabled={processing} sx={{ pl: 1.5, }} >
                                                        作成中
                                                        {
                                                            location.state?.canEdit ?
                                                                <BorderColorSharpIcon color="primary" sx={{ mb: 1 }} />
                                                                :
                                                                <VisibilityIcon color="disabled" />
                                                        }
                                                    </Works>
                                                </CLTableCell>
                                                :
                                                row.status === 2 ?
                                                    <CLTableCell align="left" onClick={() => onSubmit_done(koji, "VR", row.reportSeqNo, row.status)} >
                                                        <Works disabled={processing} sx={{ pl: 1.5, color: "#d32f2f" }}>
                                                            作成済
                                                            {
                                                                location.state?.canEdit ?
                                                                    <FileDownloadIcon />
                                                                    :
                                                                    <VisibilityIcon />
                                                            }
                                                        </Works>
                                                    </CLTableCell>
                                                    :
                                                    row.status === 3 ?
                                                        <CLTableCell align="left" onClick={() => onSubmit_done(koji, "VR", row.reportSeqNo, row.status)} >
                                                            <Works disabled={processing} sx={{ pl: 1.5 }}>
                                                                作成済
                                                                {
                                                                    location.state?.canEdit ?
                                                                        <FileDownloadIcon />
                                                                        :
                                                                        <VisibilityIcon />
                                                                }
                                                            </Works>
                                                        </CLTableCell>
                                                        :
                                                        row.status === 4 ?
                                                            <CLTableCell align="left" onClick={() => onSubmit_done(koji, "VR", row.reportSeqNo, row.status)} >
                                                                <Works disabled={processing} sx={{ pl: 1.5 }}>
                                                                    作成済<br />(確定)
                                                                    {
                                                                        location.state?.canEdit ?
                                                                            <FileDownloadIcon />
                                                                            :
                                                                            <VisibilityIcon />
                                                                    }
                                                                </Works>
                                                            </CLTableCell>
                                                            : null
                                            }

                                            {deleteAuth ?
                                                <CLTableCell align="left" onClick={() => onSubmit_delete(koji, "VR", row.reportSeqNo, row.mngNo)} >
                                                    <DeleteForeverIcon sx={{ mb: 1 }} />
                                                </CLTableCell>
                                                :
                                                null
                                            }

                                            <LoadingDialog load={processing_search} />

                                        </TableRow>
                                    )
                                })
                        }
                    </TableBody>
                </Table>
            </TableFlame>

            {keyData ?
                <TablePagination
                    component="div"
                    count={keyData?.visitInfo?.length}
                    labelRowsPerPage="表示件数"
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 30, 50]}
                    page={page}
                    labelDisplayedRows={(from, to,
                        count = keyData?.visitInfo?.length) => (`全${count}件中　${from.from}件～${from.to === -1 ? from.count : from.to}件を表示  `)}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                : <Grid />
            }

        </InspectionContents >
    </React.Fragment>
    );
}